import React, { memo, useState } from 'react'
import PropTypes from 'prop-types'
import { useFormContext, Controller } from 'react-hook-form'

import { TextField, InputAdornment, IconButton } from '@material-ui/core'
import { Close as CloseIcon } from '@material-ui/icons'

import { ConfirmationDialog } from 'components'

import useSnackbar from 'hooks/useSnackbar'
import useCookieBanner from 'hooks/useCookieBanner'

import * as service from 'service'
import helpers from 'helpers'

const BannerUrlField = ({ field, index, remove }) => {
  const { banner } = useCookieBanner()
  const [openDialog, setOpenDialog] = useState(false)
  const { control, errors } = useFormContext()
  const snackbar = useSnackbar()

  const handleOpenDialog = () => {
    // Se não tem ID, remove diretamente
    if (!field.id) {
      return remove(index)
    }

    // Se tem ID, abre o dialog de confirmação
    setOpenDialog(true)
  }

  const handleConfirmRemove = async () => {
    try {
      await service.cookies.bannerUrl.destroy({
        bannerId: banner?.id,
        bannerUrlId: field.id,
      })

      remove(index)
      snackbar.open({
        message: 'Url removida com sucesso',
        variant: 'success',
      })
    } catch (error) {
      snackbar.open({
        message: helpers.formatters.errorMessage(error?.response?.data?.error),
        variant: 'error',
      })
    } finally {
      setOpenDialog(false)
    }
  }

  return (
    <>
      <Controller
        name={`urls[${index}].id`}
        control={control}
        defaultValue={field.id || ''}
        as={<input type="hidden" />}
      />
      <Controller
        name={`urls[${index}].url`}
        control={control}
        defaultValue={field.url || ''}
        as={
          <TextField
            label="URL"
            error={!!errors?.urls?.[index]?.url}
            helperText={errors?.urls?.[index]?.url?.message}
            fullWidth
            InputProps={{
              endAdornment:
                index !== 0 ? (
                  <InputAdornment position="end">
                    <IconButton
                      aria-label="remover url"
                      onClick={handleOpenDialog}
                      edge="end"
                    >
                      <CloseIcon />
                    </IconButton>
                  </InputAdornment>
                ) : null,
            }}
          />
        }
      />
      <ConfirmationDialog
        open={openDialog}
        setOpen={setOpenDialog}
        text="Tem certeza que deseja remover esta URL?"
        textButton="Remover"
        actionAcceptButton={handleConfirmRemove}
      />
    </>
  )
}

BannerUrlField.propTypes = {
  field: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    url: PropTypes.string,
  }).isRequired,
  index: PropTypes.number.isRequired,
  remove: PropTypes.func.isRequired,
}

export default memo(BannerUrlField)
